/**
 * Provides access to global Liquid variables available from the visitor context
 * These variables are populated by the snippet sources and available for use in
 * Liquid templates throughout the application
 */
export function useGlobalLiquidVariables() {
  return {
    currentpage: [
      {
        liquid: '{{ currentpage.title }}',
        description: 'Title of the current page'
      },
      {
        liquid: '{{ currentpage.url }}',
        description: 'Full URL of current page'
      },
      {
        liquid: '{{ currentpage.pathname }}',
        description: 'Path of current page (e.g., /pricing)'
      },
      {
        liquid: '{{ currentpage.hostname }}',
        description: 'Domain name (e.g., example.com)'
      }
    ],
    referrer: [
      {
        liquid: '{{ referrer.url }}',
        description: 'Full URL of referring page (first visit)'
      },
      {
        liquid: '{{ referrer.domain }}',
        description: 'Domain of referring site (first visit)'
      },
      {
        liquid: '{{ referrer.path }}',
        description: 'Path of referring page (first visit)'
      }
    ],
    utm: [
      {
        liquid: '{{ utm.source }}',
        description: 'UTM source (first touch attribution)'
      },
      {
        liquid: '{{ utm.medium }}',
        description: 'UTM medium (first touch attribution)'
      },
      {
        liquid: '{{ utm.campaign }}',
        description: 'UTM campaign (first touch attribution)'
      },
      {
        liquid: '{{ utm.term }}',
        description: 'UTM term (first touch attribution)'
      },
      {
        liquid: '{{ utm.content }}',
        description: 'UTM content (first touch attribution)'
      },
      {
        liquid: '{{ utm.current.source }}',
        description: 'UTM source (current page)'
      },
      {
        liquid: '{{ utm.current.medium }}',
        description: 'UTM medium (current page)'
      },
      {
        liquid: '{{ utm.current.campaign }}',
        description: 'UTM campaign (current page)'
      },
      {
        liquid: '{{ utm.current.term }}',
        description: 'UTM term (current page)'
      },
      {
        liquid: '{{ utm.current.content }}',
        description: 'UTM content (current page)'
      }
    ],
    location: [
      {
        liquid: '{{ location.country }}',
        description: 'Visitor country code (e.g., US)'
      },
      {
        liquid: '{{ location.city }}',
        description: 'Visitor city name'
      }
    ],
    query: [
      {
        liquid: '{{ query.current.PARAM_NAME }}',
        description: 'Access any URL query parameter by name'
      }
    ],
    jsdata: [
      {
        liquid: '{{ jsdata.VARIABLE_NAME }}',
        description: 'Access any JavaScript window variable by name'
      }
    ],
    datalayer: [
      {
        liquid: '{{ datalayer.KEY }}',
        description: 'A value pushed to the Google Tag Manager dataLayer, e.g. {{ datalayer.user.plan }}'
      },
      {
        liquid: "{{ datalayer.ecommerce.value | default: '' }}",
        description: 'The latest ecommerce value, with a fallback when nothing was pushed'
      }
    ]
  }
}
